import { AppIntroFlow } from '@components/AppIntroFlow/index';
import { Trans, useTranslation } from 'react-i18next';
import { ClosingBody, ClosingSidebar } from '@components/Closing/index';
import { useStoreState } from 'easy-peasy';
import { candidatesSelector } from '@model/Candidate/Candidate.selectors';
import { useParams } from 'react-router-dom';

const Closing = () => {
  const { t } = useTranslation();
  const { entityId: jobId } = useParams();
  const { results: candidates } = useStoreState(candidatesSelector) || [];

  const closingApplications =
    candidates?.filter(
      application => !!application.offer && !!application.offer.acceptedAt,
    ) || [];

  return (
    <section data-testid="closing-page">
      <div className="rev-o-container">
        <div className="rev-o-grid">
          <div className="rev-u-px-16 rev-o-col-12 rev-o-col--medium-6">
            <AppIntroFlow
              title={t('closing.header.title')}
              body={<Trans i18nKey="closing.header.subtitle" />}
            />

            <ClosingBody closings={closingApplications} jobId={jobId} />
          </div>

          <div className="rev-u-px-16 rev-o-col-12 rev-o-col--medium-6">
            <ClosingSidebar hasClosings={!!closingApplications.length} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Closing;
